// Shared framer-motion variants used across step screens.
// Faithfully reconstructed from the deployed build (honours reduced-motion).
import type { Variants, Transition } from "framer-motion";

export const EASE: Transition = { duration: 0.35, ease: [0.22, 1, 0.36, 1] };

export const stepVariants: Variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: EASE },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2 } },
};

export const staggerParent: Variants = {
  initial: {},
  animate: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
};

export const staggerChild: Variants = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0, transition: EASE },
};

function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Flatten variants to a no-op fade when the user prefers reduced motion. */
export function respectMotion(variants: Variants): Variants {
  if (!prefersReducedMotion()) return variants;
  const flat: Variants = {};
  for (const key of Object.keys(variants)) flat[key] = { opacity: 1 };
  return flat;
}
